var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar-search-results" },
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.search.length === 0 && _vm.suggestions.length > 0
          ? _c(
              "ul",
              {
                key: "suggestions",
                staticClass: "navbar-search-results__suggestions"
              },
              [
                _c(
                  "li",
                  { staticClass: "navbar-search-results__suggestions-title" },
                  [_vm._v("Suggested Searches:")]
                ),
                _vm._l(_vm.suggestions, function(suggestion) {
                  return _c(
                    "li",
                    {
                      key: suggestion,
                      staticClass: "navbar-search-results__suggestions-item"
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "tab",
                                  9,
                                  $event.key,
                                  "Tab"
                                )
                              ) {
                                return null
                              }
                              return _vm.tabOut(suggestion)
                            },
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("selected", suggestion)
                            }
                          }
                        },
                        [_vm._v(_vm._s(suggestion))]
                      )
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm.search.length > 0
          ? _c(
              "div",
              { key: "results", staticClass: "navbar-search-results__results" },
              [
                _c(
                  "div",
                  { staticClass: "navbar-search-results__results-info" },
                  [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "heading heading--4 navbar-search-results__results-info-title"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.searchResults.length) + " Results for "
                        ),
                        _c("strong", [_vm._v(_vm._s(_vm.search))])
                      ]
                    ),
                    _vm.searchResults.length > 0
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "heading heading--5 navbar-search-results__results-info-subtitle"
                          },
                          [_vm._v("Press enter to see all results")]
                        )
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "navbar-search-results__results-products" },
                  _vm._l(_vm.searchResults, function(product) {
                    return _c("product-tile", {
                      key: product.id,
                      attrs: {
                        product: product,
                        tileColor: _vm.productImageBackgroundColor,
                        horizontal: ["mobile"].includes(_vm.$mq)
                      }
                    })
                  }),
                  1
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }